// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/industrie-4-0/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const industrie40DE: PageEntry = {
  id: "post.industrie-4-0",
  locale: "de",
  slug: "industrie-4-0",
  seo: {
    title: "Industrie 4.0 | Dietz GmbH",
    description: "Industrie 4.0",
  },
  type: "post",
  h1: "Industrie 4.0",
  blocks: [
    { kind: "heading", level: 2, text: "Industrie 4.0" },
    { kind: "paragraph", text: "In unserem Werk in Sonneberg haben wir verschiedene Fertigungsanlagen mit hohem Automatisierungsgrat." },
    { kind: "paragraph", text: "Baugruppenmontage, Fertigungslinien mit integrierter Laserverschweißung, sowie Verbundanlagen im Bereich Kunststofftechnik, in der verschiedene 100% Prüf- und Stanzverfahren integriert sind." },
    { kind: "paragraph", text: "Unsere Logistik ist mit einem Fahrerlosen Transportsystem ausgestattet." },
    { kind: "paragraph", text: "Alle Materialbewegungen am Standort Sonneberg werden durch Buchungstätigkeiten direkt am Arbeitsplatz umgesetzt." },
    { kind: "paragraph", text: "Ein System, welches die Rüsttätigkeiten unserer Mitarbeiter unterstützt und Buchungen in unserem ERP System lückenlos dokumentiert werden." },
    { kind: "paragraph", text: "Um uns für die Zukunft besser zu rüsten ist uns eine umfassende Digitalisierung der Produktion sehr wichtig." }
  ],
};
